import { LuPhoneCall, LuMail, LuMessageSquare } from "react-icons/lu";

const contactInfo = [
  {
    id: 1,
    icon: <LuPhoneCall />,
    title: "call me",
    action: "tel:+201111705681",
    label: "01111705681",
  },
  {
    id: 2,
    icon: <LuMail />,
    title: "send email",
    action: "mailto:abdallasalehco@gmail.com",
    label: "abdallasalehco@gmail.com",
  },
  {
    id: 3,
    icon: <LuMessageSquare />,
    title: "text me",
    action: "https://wa.me/201111705681",
    label: "Chat on WhatsApp",
  },
];

export default contactInfo;
